import { Button, Modal } from "antd";
import { FC } from "react";
import { ClassFormat } from "utils/format/ClassFormat";
import { DataFormat } from "utils/format/DataFormat";
import { strings } from "utils/localizedStrings";
import icAddress from "assets/images/ic_address.png";
import icBank from "assets/images/ic_bank.png";
import icCard from "assets/images/ic_card.png";
import icCopy from "assets/images/ic_copy.png";
import icSwiftCode from "assets/images/ic_swift_code.png";

import isEmpty from "lodash/isEmpty";
interface TopupInfoModalProps {
  open: boolean;
  onClose: () => void;
}

const TopupInfoModal: FC<TopupInfoModalProps> = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={550}
      styles={{ header: { textAlign: "center" } }}
      closeIcon={
        <div className="w-[32px] h-[32px] rounded-full border-2 border-[#9CA3AF] flex items-center justify-center">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="18"
              y1="6"
              x2="6"
              y2="18"
              stroke="#4B5563"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <line
              x1="6"
              y1="6"
              x2="18"
              y2="18"
              stroke="#4B5563"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </div>
      }
      title={
        <p className="text-[18px] font-[700] leading-none">
          {strings.TopupInfo.Title}
        </p>
      }
    >
      <div className="flex flex-col items-center text-center gap-y-2 py-2 mt-3">
        <div className={ClassFormat.topupInfoLabel}>
          {strings.TopupInfo.AccountName}
        </div>
        <div
          className={ClassFormat.topupInfoValue}
          onClick={async () =>
            await DataFormat.clickToCopy(
              strings.TopupInfo.Company
            )
          }
        >
          {strings.TopupInfo.Company}
        </div>

        <div className="h-[1px] w-full bg-[#E5E7EB] my-1" />

        {/* Account number + Swift code card */}
        <div className="w-full px-3">
          <div className="w-full rounded-2xl bg-[#F3F4F6] px-4 py-3">
            <div className="flex w-full justify-between gap-x-6">
              {/* Account number */}
              <div className="flex-1 flex flex-col items-start text-left gap-y-1">
                <div className="flex items-center w-full justify-between gap-2">
                  <div className="flex items-center gap-2 text-[#6B7280] text-[14px] font-[600]">
                    <span>{strings.TopupInfo.AccountNo}</span>
                  </div>
                  <button
                    aria-label="Copy account number"
                    className="p-1 rounded hover:bg-[#E5E7EB]"
                    onClick={async () => await DataFormat.clickToCopy(strings?.TopupInfo.AccountNumber)}
                  >
                    <img src={icCopy} alt="Copy" className="w-[18px] h-[18px]" />
                  </button>
                </div>
                <div
                  className="flex items-center gap-2 cursor-pointer"
                  onClick={async () => await DataFormat.clickToCopy(strings?.TopupInfo.AccountNumber)}
                >
                  <img src={icCard} alt="Account number" className="w-[28px] h-[28px]" />
                  <span className={`${ClassFormat.topupInfoValue} !text-left !mt-0`}>{strings?.TopupInfo.AccountNumber}</span>
                </div>
              </div>

              {/* Swift code */}
              {!isEmpty(strings?.TopupInfo.SwiftCode) && <div className="flex-1 flex flex-col items-start text-left gap-y-1">
                <div className="flex items-center w-full justify-between gap-2">
                  <div className="flex items-center gap-2 text-[#6B7280] text-[14px] font-[600]">
                    <span>{"Swift Code"}</span>
                  </div>
                  <button
                    aria-label="Copy swift code"
                    className="p-1 rounded hover:bg-[#E5E7EB]"
                    onClick={async () => await DataFormat.clickToCopy(strings?.TopupInfo.SwiftCode)}
                  >
                    <img src={icCopy} alt="Copy" className="w-[18px] h-[18px]" />
                  </button>
                </div>
                <div
                  className="flex items-center gap-2 cursor-pointer"
                  onClick={async () => await DataFormat.clickToCopy(strings?.TopupInfo.SwiftCode)}
                >
                  <img src={icSwiftCode} alt="Swift code" className="w-[28px] h-[28px]" />
                  <span className={`${ClassFormat.topupInfoValue} !text-left !mt-0`}>{strings?.TopupInfo.SwiftCode}</span>
                </div>
              </div>}
            </div>
          </div>
        </div>

        {/* Bank card */}
        <div className="w-full px-3 mt-3">
          <div className="w-full rounded-2xl bg-[#F3F4F6] px-4 py-3 text-left">
            <div className="flex items-center w-full justify-between gap-2">
              <div className="flex items-center gap-2 text-[#6B7280] text-[14px] font-[600]">
                <span>{strings.TopupInfo.Bank}</span>
              </div>
              <button
                aria-label="Copy bank name"
                className="p-1 rounded hover:bg-[#E5E7EB]"
                onClick={async () =>
                  await DataFormat.clickToCopy(strings.TopupInfo.BankName)
                }
              >
                <img src={icCopy} alt="Copy" className="w-[18px] h-[18px]" />
              </button>
            </div>
            <div
              className="flex items-start gap-2 cursor-pointer mt-1"
              onClick={async () =>
                await DataFormat.clickToCopy(strings.TopupInfo.BankName)
              }
            >
              <img src={icBank} alt="Bank" className="w-[28px] h-[28px] mt-[2px]" />
              <span className={`${ClassFormat.topupInfoValue} !text-left !mt-0`}>{strings.TopupInfo.BankName}</span>
            </div>
          </div>
        </div>

        {/* Address card */}
        <div className="w-full px-3 mt-3">
          <div className="w-full rounded-2xl bg-[#F3F4F6] px-4 py-3 text-left">
            <div className="flex items-center w-full justify-between gap-2">
              <div className="flex items-center gap-2 text-[#6B7280] text-[14px] font-[600]">
                <span>{strings.GlobalLabels.Address}</span>
              </div>
              <button
                aria-label="Copy address"
                className="p-1 rounded hover:bg-[#E5E7EB]"
                onClick={async () =>
                  await DataFormat.clickToCopy(strings.TopupInfo.BankAddress)
                }
              >
                <img src={icCopy} alt="Copy" className="w-[18px] h-[18px]" />
              </button>
            </div>
            <div
              className="flex items-start gap-2 cursor-pointer mt-1"
              onClick={async () =>
                await DataFormat.clickToCopy(strings.TopupInfo.BankAddress)
              }
            >
              <img src={icAddress} alt="Address" className="w-[28px] h-[28px] mt-[2px]" />
              <span className={`${ClassFormat.topupInfoValue} !text-left !mt-0`}>{strings.TopupInfo.BankAddress}</span>
            </div>
          </div>
        </div>

        <Button
          type="primary"
          size="large"
          className="mt-2 px-8"
          onClick={onClose}
        >
          {strings.GlobalLabels.Close}
        </Button>
      </div>
    </Modal>
  );
};

export default TopupInfoModal;
